import React, { createContext, useEffect, useState } from "react";
import Home from "../Templates/Home/Home";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { useJwt } from "react-jwt";
import { userContext } from "../Contexts/userContext";
import { Fetch } from "../Hooks/Fetch";
import { userInfo } from "../Hooks/URL";
import useFetch from "../Hooks/useFetch";
import useFetchWhen from "../Hooks/useFetchWhen";

function HomePage() {
  const [cookies] = useCookies(["TOKEN"]);
  const navigate = useNavigate();

  const { decodedToken, isExpired } = useJwt(cookies.TOKEN);
  const [user, setUser] = useState("");
  const [contextData, setContextData] = useState({
    page: "",
    role: "",
    data: "",
    link: "",
    user: "",
  });

  const { data, loading } = useFetchWhen(userInfo, user == "");

  useEffect(() => {
    if (data?.data) {
      setContextData({ ...contextData, user: data?.data });
      setUser(data);
    }
  }, [data]);

  // useEffect(() => {
  //   if (user?.name) {
  //   }
  // }, [user]);

  // useEffect(() => {
  //   if (!cookies.TOKEN) {
  //     navigate("/login");
  //   }
  // }, [cookies]);

  // useEffect(() => {
  //   if (cookies.TOKEN && !contextData.user?.name)
  //     Fetch(userInfo, cookies, { function: setUser });
  // }, [cookies]);

  return (
    <userContext.Provider value={{ contextData, setContextData }}>
      <Home />
    </userContext.Provider>
  );
}

export default HomePage;
